import { isFlagEnabled } from "js/utilities";
import { useTranslation } from "react-i18next";
export const usePolicyDetailLinks = (isAnnuity = false) => {
  const { t } = useTranslation();
  return [
    {
      heading: t("CustomerPolicyDetails-view-transactions"),
      links: [
        {
          id: "1",
          name: t("CustomerPolicyDetails-view-transactions-link1"),
          route: "/payment/make-a-payment",
        },
        {
          id: "2",
          name: isAnnuity
            ? ""
            : t("CustomerPolicyDetails-view-transactions-link2"),
          route: isAnnuity ? "" : "/messages",
        },
        {
          id: "3",
          name: t("CustomerPolicyDetails-view-transactions-link3"),
          route: "/payment/billing",
        },
      ],
    },
    {
      heading: t("CustomerPolicyDetails-manage-service-requests-claims"),
      links: [
        {
          id: "1",
          name: t("CustomerPolicyDetails-manage-service-requests-claims-link1"),
          route: "/services-claims/forms",
        },
        {
          id: "2",
          name: t("CustomerPolicyDetails-manage-service-requests-claims-link2"),
          route: "/services-claims/claims/file-a-claim",
        },
        ...(isFlagEnabled("ENABLE_POLICY_DETAIL_PAGE_TO_RELATED_FORMS_PAGE")
          ? [
              {
                id: 3,
                name: t(
                  "CustomerPolicyDetails-manage-service-requests-claims-link3"
                ),
                route: "/services-claims/forms",
              },
            ]
          : []
        ).concat([
          {
            id: "4",
            name: t(
              "CustomerPolicyDetails-manage-service-requests-claims-link4"
            ),
            route: "/profile",
          },
          {
            id: "5",
            name: t(
              "CustomerPolicyDetails-manage-service-requests-claims-link5"
            ),
            route: "/services-claims/forms",
          },
          {
            id: "6",
            name: t(
              "CustomerPolicyDetails-manage-service-requests-claims-link6"
            ),
            route: "",
          },
        ]),
      ],
    },
  ];
};
